import React from 'react';
import Dashboard from '../globals/components/Dashboard';
import { AccountBalance, Calculate, AutoAwesome } from '@mui/icons-material';
import { CircularProgress, Box } from '@mui/material';
import Navbar from '../globals/components/Navbar';
import { setTeamMemberId } from '../store/slices/teamMemberSlice';  // Corrected import
import { apiClient } from '../api/httpClient';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const CarrierTeamMemberDashboard = () => {
    const data = useSelector((state) => state.auth);
    const teamMemberId = useSelector((state) => state.teamMember?.teamMemberId);
    const dispatch = useDispatch();
  
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (teamMemberId !== undefined && teamMemberId !== null) {
            setLoading(false);
            return;
        }

        const fetchTeamMemberDetails = async () => {
          try {
            const response_user = await apiClient(`/get-team-member-id/${data.user.id}/`, 'GET');
            dispatch(setTeamMemberId(response_user.team_member_id));  // Dispatch the action
            setLoading(false);
          } catch (error) {
            console.error(error);
            setLoading(false);
          }
        };
    
        fetchTeamMemberDetails();
    }, [data.user.id, dispatch, teamMemberId]);

    const links = [
        [
            { name: 'Bonds to Approve', path: '/vermost_approve_bonds_teammember', icon: <AccountBalance /> }, // Bank icon for "Carriers"
        ],
        [
            { name: 'Premium Calculator', path: '/premium_calculator', icon: <Calculate /> },
            { name: 'Enhancement Requests', path: '/create-enhancement-request', icon: <AutoAwesome /> },
        ],
    ];

    if (loading) {
        return (
            <>
                <Navbar />
                <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                    <CircularProgress />
                </Box>
            </>
        );
    }

    return (
        <>
            <Navbar />
            <Dashboard title="Liberty Team Member Dashboard" links={links} />
        </>
    );
};

export default CarrierTeamMemberDashboard;